import React, { useContext } from "react";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_FILE_URL, BASE_URL } from "../../../constant";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import AlarmSettings from "../../master/alarm/AlarmSettings";
import DeviceImportPopup from "./DeviceImportPopup";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import BtnLoader from "../../BtnLoader";
import AlarmViewer from "./AlarmViewer";
import AppContext from "../../../AppContext";
import { useTranslation } from "react-i18next";

const AssetTypePropertyForm = () => {
  const navigate = useNavigate();
  const { authCtx, darkMode } = useContext(AppContext);
  const { header, id, selectedId } = useParams();
  const { t } = useTranslation();
  const [asset, setAsset] = useState();
  const [parentAssets, setParentAssets] = useState([]);
  const [haveParent, setHaveParent] = useState(false);
  // const [companies, setCompanies] = useState([]);
  const [details, setDetails] = useState({
    name: "",
    active: true,
    assetType: { id: id, name: header },
    devices: [],
    parameters: [],
    properties: [],
    alarms: [],
    companyAssign: false,
  });
  const [loading, setLoading] = useState({
    formLoading: false,
    imageLoading: false,
  });
  const [dropDownData, setDropDownData] = useState([]);

  const onValueChange = (e, props) => {
    setDetails((prev) => {
      return {
        ...prev,
        properties: prev.properties.map((p) =>
          p.id === props.id ? { ...p, value: e.target.value } : p
        ),
      };
    });
  };
  const onCheckboxChange = (e) => {
    setDetails((pre) => ({
      ...pre,
      [e.target.name]: e.target.checked,
      company:
        e.target.name === "companyAssign" && !e.target.checked
          ? null
          : pre.company,
      companyId: !e.target.checked ? null : pre.companyId,
    }));
  };

  const onDeviceChange = (e, parameterId) => {
    setDetails((pre) => ({
      ...pre,
      parameters: pre.parameters.map((p, i) =>
        p.parameterId === parameterId
          ? {
              ...p,
              deviceId: e.value.device.id,
              sensorId: null,
              unit: null,
            }
          : p
      ),
      alarms: pre.alarms.map((a) =>
        a.parameterId === parameterId
          ? { ...a, deviceId: e.value.device.id }
          : a
      ),
    }));
  };

  const onParameterToggleEnable = (e, itemId) => {
    setDetails({
      ...details,
      parameters: details.parameters.map((d) =>
        d.id === itemId ? { ...d, enabled: !d.enabled } : d
      ),
    });
  };

  const onAlarmToggleEnable = (e, itemId) => {
    setDetails({
      ...details,
      alarms: details.alarms.map((d) =>
        d.parameterId === itemId ? { ...d, enabled: !d.enabled } : d
      ),
    });
  };

  const handleSensorChange = (e, parameterId) => {
    setDetails({
      ...details,
      parameters: details.parameters.map((p, id) =>
        p.parameterId === parameterId
          ? {
              ...p,
              sensorId: e.value.sensorId,
              unit: e.value.unit,
            }
          : p
      ),
      alarms: details.alarms.map((a) =>
        a.parameterId === parameterId ? { ...a, sensorId: e.value.sensorId } : a
      ),
    });
  };

  const handleFileChange = async (event) => {
    const acceptedRatio = 16 / 9; // The required aspect ratio (16:9)
    const config = { headers: { "Content-Type": "multipart/form-data" } };
    const formData = new FormData();
    const selectedFile = event.target.files[0];

    // Check if a file was selected
    if (selectedFile) {
      const image = new Image();
      image.src = URL.createObjectURL(selectedFile);

      image.onload = () => {
        const aspectRatio = image.width / image.height;
        if (Math.abs(aspectRatio - acceptedRatio) < 0.01) {
          // Aspect ratio is close enough to 16:9
          formData.append("files", selectedFile);
          axios
            .post(`${BASE_URL}/Storage/file/upload`, formData, config)
            .then((res) => {
              setDetails((pre) => ({ ...pre, imageId: res.data[0].id }));
            })
            .catch((error) => {
              // Handle the upload error
              console.error("Error occurred during upload:", error.message);
            });
        } else {
          // Aspect ratio is not 16:9
          toast.error("Please select an image with a 16:9 aspect ratio.");
        }
      };
    } else {
      // No file selected
      toast.error("Please select an image.");
    }
  };

  const onCloseClick = () => {
    navigate(`/assettypepropertylist/${header}/${id}`);
  };

  const loadProperties = async () => {
    let res = await axios.get(`${BASE_URL}/AssetType/${id}`);
    const data = res.data;
    let detailsData = {
      ...details,
      parentTemplateId: data.parentId,
      assetType: { id: id, name: data.name },
      properties: data.properties.map((p) => ({
        id: p.id,
        key: p.name,
        value: "",
        isLocation: p.type === "GeoLocation" ? true : false,
      })),
      parameters: data.parameters.map((p) => ({
        ...p,
        // typeData: typeData.find((td) => td.id === p.type).value,
        enabled: true,
        default: false,
        type: p.type,
      })),
      alarms: data.alarms,
    };
    if (details.imageId === null || details.imageId === undefined) {
      detailsData = { ...detailsData, imageId: data.imageId };
    }
    // setDetails(detailsData);
    const optionDatas = data.properties.map((prps) =>
      prps.options.includes(",")
        ? {
            ...prps,
            optionsData: prps.options.split(","),
          }
        : {
            ...prps,
            optionsData: [prps.options],
          }
    );
    setAsset({
      ...data,
      properties: optionDatas.map((one) => ({
        ...one,
        optionsData: one.optionsData,
      })),
    });
    return detailsData;
  };

  const loadData = async (assetTypeData) => {
    if (selectedId !== "new") {
      let res = await axios.get(`${BASE_URL}/api/Asset/${selectedId}`);
      setDetails({
        ...assetTypeData,
        ...res.data,
        imageId:
          res.data.imageId !== null ? res.data.imageId : assetTypeData.imageId,
        assetType: { id: id, name: header },
        properties: assetTypeData.properties.map((x) => {
          const assetProp = res.data.properties.find((y) => y.id === x.id);
          return assetProp || x;
        }),
        // company:
        //   res.data.companyId &&
        //   companyData.find((x) => x.id === res.data.companyId),
      });
      loadDeviceSensors(res.data);
    }
  };

  const loadParentAssets = async (assetTypeId) => {
    setLoading(true);
    const companyId = authCtx.profile.companyId;
    const resData = await axios.get(
      `${BASE_URL}/api/Asset?assetTypeId=${assetTypeId}&companyId=${companyId}&userRole=${authCtx.profile.role}`
    );
    if (resData.status === 200) {
      setParentAssets(resData.data);
    }
  };

  const onSubmit = async () => {
    if (details?.parentname === "" || details?.name === undefined) {
      toast.error("Name is required");
    } else {
      setLoading((pre) => ({ ...pre, formLoading: true }));
      const payload = {
        ...details,
        companyId:
          // authCtx.profile.role !== 100
          //   ?
          authCtx.profile.companyId,
        // : details.companyId,
      };
      if (!payload.id) {
        const res = await axios.post(`${BASE_URL}/api/Asset`, payload);
        const asset = { ...payload, id: res.data };
        setDetails(asset);
        if (res.status) {
          toast.success("Asset created successfully");
          navigate(`/assettypepropertyform/${header}/${id}/${res.data}`);
        } else {
          toast.error("some error occured");
        }
      } else {
        const res = await axios.post(`${BASE_URL}/api/Asset`, payload);
        if (res.status) {
          toast.success("Asset updated successfully");
        } else {
          toast.error("some error occured");
        }
      }
      setLoading((pre) => ({ ...pre, formLoading: false }));
    }
  };

  const onHandleChange = (p, e) => {
    setDetails((pre) => ({
      ...pre,
      parameters: pre.parameters.map((param) =>
        param.id === p.id
          ? { ...param, [e.target.name]: e.target.value }
          : param
      ),
    }));
  };

  const loadDeviceSensors = async (data) => {
    const deviceIds = data.devices.map((d) => {
      return d.device.id;
    });
    let res = await axios.post(
      `${BASE_URL}/api/Device/GetDevicesByDeviceIds`,
      deviceIds
    );
    if (res.status === 200) setDropDownData(res.data);
  };

  // const loadLookupData = async () => {
  //   let res = await axios.get(`${BASE_URL}/api/CompanyMaster`);
  //   if (res.status === 200) {
  //     const data = res.data;
  //     setCompanies(data);
  //     return data;
  //   }
  // };

  const loadLookupsData = async () => {
    // const resCompanies = await loadLookupData();
    const assetTypeData = await loadProperties();
    if (
      assetTypeData.parentTemplateId &&
      assetTypeData.parentTemplateId !== null
    ) {
      setHaveParent(true);
      loadParentAssets(assetTypeData.parentTemplateId);
    }
    if (selectedId !== "new") loadData(assetTypeData);
    else
      setDetails({
        ...assetTypeData,
        companyAssign: authCtx.profile.companyId !== null,
        companyId: authCtx.profile.companyId,
        // company:
        //   authCtx.profile.companyId &&
        //   resCompanies.find((x) => x.id === authCtx.profile.companyId),
      });
  };

  useEffect(() => {
    loadLookupsData();
    // loadDeviceTypes();
  }, []);

  // useEffect(() => {
  // }, [asset]);

  const onDelete = (item, onClose) => {
    const filteredParameters = details.parameters.filter(
      (p) =>
        !(
          p.deviceId === item.device.id &&
          p.deviceTypeId === item.deviceType.id &&
          p.default
        )
    );
    const filteredParams = details.parameters.filter(
      (p) =>
        p.deviceId === item.device.id &&
        p.deviceTypeId === item.deviceType.id &&
        p.default
    );

    const filteredAlarms = details.alarms.filter(
      (x) => !filteredParams.some((y) => y.id === x.parameterId)
    );

    setDetails((pre) => ({
      ...pre,
      devices: pre.devices.filter(
        (d, i) =>
          !(
            d.device.id === item.device.id &&
            d.deviceType.id === item.deviceType.id
          )
      ),
      parameters: filteredParameters.map((fp) =>
        fp.deviceId === item.device.id ? { ...fp, deviceId: null } : fp
      ),
      alarms: filteredAlarms,
    }));
    if (onClose) onClose();
  };

  const onDeleteDevice = (item, index) => {
    const chechDeviceLinks = details.parameters.some(
      (s) => !s.default && s.deviceId === item.device.id
    );
    if (chechDeviceLinks)
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="popup w-80 px-4 py-2 rounded bg-neutral-900 shadow bg-gradient-to-b ">
              <p className="text-lg font-semibold text-slate-300 mb-2">
                Confirm
              </p>
              <p className="text-sm font-semibold text-slate-300">
                Are you sure you want to delete the device?
                <br /> <br /> [Device Name:&nbsp;
                <span className="text-red-400">
                  {item.device.name}
                </span>&nbsp;] <br />
                <br />
                This action will also unlink the associated parameters with the
                device.
              </p>
              <div className="flex justify-end text-sm font-medium gap-3 mt-4">
                <button
                  onClick={() => onDelete(item, onClose)}
                  className="px-3 py-1 bg-purple-700 text-slate-300 rounded-lg"
                >
                  Yes
                </button>
                <button
                  onClick={() => onClose()}
                  className="px-3 py-1 bg-white text-black rounded-lg"
                >
                  No
                </button>
              </div>
            </div>
          );
        },
      });
    else onDelete(item, null);
  };

  const onImportDevice = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <DeviceImportPopup
            // popup={onClose}
            setPopup={onClose}
            setDetails={setDetails}
            details={details}
            loadDeviceSensors={loadDeviceSensors}
            authCtx={authCtx}
            darkMode={darkMode}
          />
        );
      },
    });
  };

  const onEditAlarm = (e, i, index, item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <AlarmSettings
            setAlarmPopup={onClose}
            setState={setDetails}
            selectedParameter={{
              ...item,
              alarmParentId: i.parameterId,
            }}
            alarmPopup={true}
            selectedAlarm={{ ...i, index: index }}
          />
        );
      },
    });
  };

  const onParamBgColorChange = (e, param) => {
    const rgbaString = e.value;
    const rgbaValues = rgbaString.match(/\d+/g); // Extract numeric values
    const [r, g, b] = rgbaValues;
    const newColor = `rgba(${r}, ${g}, ${b}, 0.7)`; // Set opacity to 0.1
    setDetails((pre) => ({
      ...pre,
      parameters: pre.parameters.map((x) =>
        x.id === param.id ? { ...x, cardBgColor: newColor } : x
      ),
    }));
  };

  const handleParentChange = (e) => {
    setDetails((pre) => ({
      ...pre,
      parentId: e.value.id,
      parentName: e.value.name,
    }));
  };

  return (
    <div className="flex flex-col relative dark:text-white text-black pl-14 py-3 dark:bg-darkModeBg bg-lightModeBg">
      <div className=" text-xs font-medium py-4 gap-3 xl:pl-5 h-[80vh] overflow-y-scroll relative">
        <div className="text-xs font-medium py-4 gap-3">
          <div className="flex justify-between w-96 lg:w-[31.9rem] mb-4 gap-3 items-center">
            <div className="flex gap-2 dark:text-white text-labels">
              <button type="button" onClick={onCloseClick}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2.0"
                  stroke="currentColor"
                  className="w-7 h-7"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
                  />
                </svg>
              </button>
              <label className=" font-bold text-lg lg:text-2xl dark:text-white text-labels">
                {asset?.name}
              </label>
            </div>
          </div>
          <label className=" font-semibold text-sm lg:text-base dark:text-white text-labels">
            {t("masters.fields.name")}
            <span className=" text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-96 lg:w-[31.9rem] h-9 mt-3"
            onChange={(e) =>
              setDetails((pre) => ({ ...pre, name: e.target.value }))
            }
            value={details?.name}
            name="name"
          ></input>
          {haveParent && (
            <div className="flex flex-col ml-[-2px]" id="parentcombo">
              <label className="dark:text-white text-labels text-sm lg:text-sm font-medium py-2">
                {t("masters.fields.parent")}
              </label>
              <div
                className={` w-96 lg:w-[31.9rem] h-9 ${
                  darkMode ? "darkCombo" : "lightCombo"
                }`}
              >
                <ComboBox
                  data={parentAssets}
                  dataItemKey="id"
                  textField="name"
                  name="parentName"
                  placeholder="Parent"
                  suggest={true}
                  clearButton={false}
                  style={{
                    fontWeight: 500,
                    fontSize: "12px",
                    paddingLeft: `15px`,
                  }}
                  className="px-5 block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light dark:text-white text-inputFieldsTxts rounded-lg mb-4 w-40 lg:w-80 h-9"
                  onChange={handleParentChange}
                  value={
                    details?.parentId
                      ? parentAssets.find((x) => x.id === details.parentId)
                      : null
                  }
                />
              </div>
            </div>
          )}
          <div className="flex">
            <div className="flex flex-col min-w-[200px] min-h-[200px]">
              <div className="font-semibold text-base lg:text-lg pt-3 dark:text-white text-labels">
                {t("masters.headerTexts.props")}
              </div>
              {asset && asset.parentname !== "" && (
                <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3 w-32">
                  {asset?.parentname}
                </label>
              )}
              {details &&
                asset?.properties.map((i, index) => (
                  <div className="flex py-3" key={index}>
                    <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3 w-32">
                      {i.name}
                    </label>
                    {i.type === "String" ? (
                      i.options === "" ? (
                        <input
                          type="text"
                          name={i.name.replace(/\s/g, "")}
                          value={
                            details.properties.find((p) => p.id === i.id)?.value
                          }
                          onChange={(e) => onValueChange(e, i)}
                          // placeholder="Label"
                          className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-96 h-9"
                        />
                      ) : (
                        <div
                          className={`w-96 h-9 ${
                            darkMode ? "darkCombo" : "lightCombo"
                          }`}
                        >
                          <ComboBox
                            data={i.optionsData}
                            name={i.name.replace(/\s/g, "")}
                            value={
                              details.properties.find((p) => p.id === i.id)
                                ?.value
                            }
                            style={{
                              fontWeight: "500",
                              fontSize: "12px",
                              paddingLeft: "10px",
                            }}
                            onChange={(e) => onValueChange(e, i)}
                            className=" block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light px-5 dark:text-white text-inputFieldsTxts rounded-lg mb-4 w-full h-full"
                          />
                        </div>
                      )
                    ) : i.type === "Number" ? (
                      i.options === "" ? (
                        <input
                          type="text"
                          name={i.name.replace(/\s/g, "")}
                          value={
                            details.properties?.find((p) => p.id === i.id)
                              ?.value
                          }
                          onChange={(e) => onValueChange(e, i)}
                          // placeholder="Label"
                          className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 bg-zinc-750 dark:text-white text-inputFieldsTxts px-5 w-96 h-9"
                        />
                      ) : (
                        <div
                          className={`w-96 h-9 ${
                            darkMode ? "darkCombo" : "lightCombo"
                          }`}
                        >
                          <ComboBox
                            data={i.optionsData}
                            value={
                              details.properties.find((p) => p.id === i.id)
                                ?.value
                            }
                            name={i.name.replace(/\s/g, "")}
                            onChange={(e) => onValueChange(e, i)}
                            className=" block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light dark:text-white text-inputFieldsTxts rounded-lg mb-4 w-full h-full"
                          />
                        </div>
                      )
                    ) : i.type === "GeoLocation" ? (
                      <input
                        type="text"
                        name={i.name.replace(/\s/g, "")}
                        value={
                          details.properties.find((p) => p.id === i.id)?.value
                        }
                        onChange={(e) => onValueChange(e, i)}
                        // placeholder="Label"
                        className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-96 h-9"
                      />
                    ) : (
                      <input
                        type="Checkbox"
                        className="focus:ring-blue-500 h-5 w-5 text-blue-600 border-gray-300 rounded mt-3"
                        name={i.label?.replace(/\s/g, "")}
                        value={
                          details.properties.find((p) => p.id === i.id)?.value
                        }
                        checked={
                          details.properties.find((p) => p.id === i.id)?.value
                        }
                        onChange={(e) => onValueChange(e, i)}
                      />
                    )}
                  </div>
                ))}
            </div>
            <div className="flex relative h-full object-cover bg-cover max-w-[50vw] ml-20 mt-20 bg-neutral-800 items-center justify-center">
              <input
                type="file"
                accept="image/*"
                className="absolute documents cursor-pointer max-h-full w-full border-0 focus:outline-none opacity-0"
                onChange={handleFileChange}
              />
              {loading.imageLoading ? (
                <div>
                  <span class="inline-flex items-center gap-px">
                    <span class="animate-blink mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                    <span class="animate-blink animation-delay-200 mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                    <span class="animate-blink animation-delay-[400ms] mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                  </span>
                </div>
              ) : details.imageId && !details.imageId.startsWith("0000") ? (
                <img
                  src={`${BASE_FILE_URL}/${details.imageId}`}
                  alt="AssetTypeIcon"
                  className="h-[35vh] w-auto object-cover overflow-hidden hover:fill-white"
                />
              ) : (
                <img
                  src="upload_asset_logo.svg"
                  alt="AssetTypeIcon"
                  className=" w-6 hover:fill-white"
                />
              )}
            </div>
          </div>
        </div>
        <div className="w-fit">
          <div className="flex text-xs w-full justify-between lg:text-sm font-medium gap-3 items-center">
            <label className="text-base dark:text-white text-labels">
              {t("masters.headerTexts.dsParams")}
            </label>
            <button
              button="button"
              className="dark:bg-neutral-800 bg-zinc-600 px-6 py-2 rounded-md"
              onClick={() => onImportDevice()}
            >
              <div className="flex justify-center items-center rounded-lg gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="grey"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-4 h-4"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 4.5v15m7.5-7.5h-15"
                  />
                </svg>
                <label className="text-xs lg:text-sm font-medium ">
                  {t("button.linkDevice")}
                </label>
              </div>
            </button>
          </div>
          {details?.devices?.map((sp, index) => (
            <div className="w-fit">
              <div className="flex justify-between text-xs font-medium py-4">
                <label>
                  {sp.device.name}&nbsp;(&nbsp;{sp.deviceType.name}&nbsp;)
                </label>
                <button onClick={() => onDeleteDevice(sp, index)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="red"
                    class="w-4 h-4"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                    />
                  </svg>
                </button>
              </div>
              {details.parameters
                .filter((p) => p.default)
                .map(
                  (s, index) =>
                    s.deviceId === sp.device.id &&
                    s.deviceTypeId === sp.deviceType.id && (
                      <div>
                        <div className="flex gap-3" id={index}>
                          <div className="flex flex-col">
                            <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                              {t("masters.fields.id")}
                            </label>
                            <label className=" flex items-center  dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-48 h-9">
                              {s.parameterId}
                            </label>
                          </div>
                          <div className="flex flex-col">
                            <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                              {t("masters.fields.name")}
                            </label>
                            <input
                              type="text"
                              name="name"
                              value={s.name}
                              onChange={(e) => onHandleChange(s, e)}
                              className=" flex items-center  dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-48 h-9"
                            ></input>
                          </div>
                          <div className="flex flex-col" id="propTypecombo">
                            <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                              {t("masters.fields.type")}
                            </label>
                            <label className="flex items-center dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-48 h-9">
                              {s.type}
                            </label>
                          </div>
                          <div className="flex flex-col">
                            <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                              {t("masters.fields.sensorName")}
                            </label>
                            <label className=" flex items-center dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-48 h-9">
                              {s.sensorName}
                            </label>
                          </div>
                          <div
                            className="flex flex-col pt-8"
                            id="propTypecombo"
                          >
                            <label className="flex items-center dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts rounded-lg mb-4 dark:text-white text-inputFieldsTxts px-5">
                              <div
                                className={`inline-flex rounded-xl group mt-1 h-8 border-2 ${
                                  s.enabled === true
                                    ? "bg-lime-700 border-lime-700"
                                    : "bg-lime-700 border-lime-700"
                                }`}
                              >
                                <button
                                  type="button"
                                  className={`text-xs font-medium text-center rounded-xl w-1/2 px-2 ${
                                    s.enabled === true
                                      ? "bg-lime-700 text-white"
                                      : "text-white bg-white"
                                  }`}
                                  onClick={(e) =>
                                    onParameterToggleEnable(e, s.id)
                                  }
                                >
                                  {t("masters.labels.enabled")}
                                </button>
                                <button
                                  type="button"
                                  className={`text-xs font-medium text-center rounded-xl w-1/2 px-2 ${
                                    s.enabled === true
                                      ? "text-white bg-white"
                                      : "bg-lime-700 text-white"
                                  }`}
                                  onClick={(e) =>
                                    onParameterToggleEnable(e, s.id)
                                  }
                                >
                                  {t("masters.labels.disabled")}
                                </button>
                              </div>
                            </label>
                          </div>
                        </div>
                        <div className="flex flex-col ml-10 mb-5">
                          {details.alarms &&
                            details.alarms.length > 0 &&
                            details.alarms.some(
                              (a) => a.parameterId === s.id
                            ) && (
                              <div className="flex gap-36">
                                <label className="text-white font-medium text-xs lg:text-sm py-1">
                                  {t("masters.headerTexts.alarms")}
                                </label>
                              </div>
                            )}
                          {details.alarms &&
                            details.alarms.map(
                              (i, index) =>
                                i.parameterId === s.id &&
                                i.deviceId === sp.device.id && (
                                  <AlarmViewer
                                    action={false}
                                    alarm={i}
                                    key={i}
                                    index={index}
                                    onAlarmToggleEnable={onAlarmToggleEnable}
                                    onEditAlarm={onEditAlarm}
                                  />
                                )
                            )}
                        </div>
                      </div>
                    )
                )}
            </div>
          ))}
        </div>
        <div className="font-semibold text-base lg:text-lg pt-3 py-2 dark:text-white text-labels">
          {t("masters.headerTexts.params")}
        </div>
        <div className="flex flex-col text-xs font-medium py-4">
          {details.parameters
            .filter((p) => !p.default)
            .map((item, index) => {
              const sensors = dropDownData[item.deviceId];
              return (
                <div className="flex flex-col" key={index}>
                  <div className="flex gap-3" id={item.id}>
                    <div className="flex flex-col">
                      <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                        {t("masters.fields.id")}
                      </label>
                      <label className=" flex items-center  dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-48 h-9">
                        {item.parameterId}
                      </label>
                    </div>
                    <div className="flex flex-col">
                      <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                        {t("masters.fields.name")}
                      </label>
                      <label className=" flex items-center  dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-48 h-9">
                        {item.name}
                      </label>
                    </div>
                    <div className="flex flex-col" id="propTypecombo">
                      <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                        {t("masters.fields.type")}
                      </label>
                      <label className="flex items-center dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-48 h-9">
                        {item.type}
                      </label>
                    </div>

                    <div className="flex flex-col" id="propTypecombo">
                      <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                        {t("masters.fields.device")}
                      </label>
                      <div
                        className={`${darkMode ? "darkCombo" : "lightCombo"}`}
                      >
                        <ComboBox
                          data={details?.devices}
                          dataItemKey="device.id"
                          textField="device.name"
                          name="type"
                          suggest={true}
                          clearButton={false}
                          style={{ fontSize: "12px", fontWeight: 500 }}
                          className=" block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light dark:text-white text-inputFieldsTxts rounded-lg mb-4 w-40 lg:w-44 h-9"
                          onChange={(e) => onDeviceChange(e, item.parameterId)}
                          value={
                            item.deviceId &&
                            details?.devices?.find(
                              (d) => d.device.id === item.deviceId
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="flex flex-col" id="propTypecombo">
                      <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                        {t("masters.fields.sensor")}
                      </label>
                      <div
                        className={`${darkMode ? "darkCombo" : "lightCombo"}`}
                      >
                        <ComboBox
                          data={sensors ? sensors : []}
                          dataItemKey="sensorId"
                          textField="name"
                          name="type"
                          suggest={true}
                          clearButton={false}
                          style={{ fontSize: "12px", fontWeight: 500 }}
                          className=" block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light dark:text-white text-inputFieldsTxts rounded-lg mb-4 w-40 lg:w-44 h-9"
                          onChange={(e) =>
                            handleSensorChange(e, item.parameterId)
                          }
                          value={
                            item.sensorId &&
                            sensors?.find((s) => s.sensorId === item.sensorId)
                          }
                        />
                      </div>
                    </div>
                    <div className="flex flex-col mt-8" id="propTypecombo">
                      <label className="flex items-center dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts rounded-lg mb-4 dark:text-white text-inputFieldsTxts px-5">
                        <div
                          className={`inline-flex rounded-xl group mt-1 h-8 border-2 ${
                            item.enabled === true
                              ? "bg-lime-700 border-lime-700"
                              : "bg-lime-700 border-lime-700"
                          }`}
                        >
                          <button
                            type="button"
                            className={`text-xs font-medium text-center rounded-xl w-1/2 px-2 ${
                              item.enabled === true
                                ? "bg-lime-700 text-white"
                                : "dark:text-white text-black bg-white"
                            }`}
                            onClick={(e) => onParameterToggleEnable(e, item.id)}
                          >
                            {t("masters.labels.enabled")}
                          </button>
                          <button
                            type="button"
                            className={`text-xs font-medium text-center rounded-xl w-1/2 px-2 ${
                              item.enabled === true
                                ? "text-white bg-white"
                                : "bg-lime-700 text-white"
                            }`}
                            onClick={(e) => onParameterToggleEnable(e, item.id)}
                          >
                            {t("masters.labels.disabled")}
                          </button>
                        </div>
                      </label>
                    </div>
                  </div>
                  {details?.alarms &&
                    details?.alarms.length > 0 &&
                    details?.alarms.some(
                      (a) => a.parameterId === item.parameterId
                    ) > 0 && (
                      <div className="flex gap-36">
                        <label className="dark:text-white text-inputFieldsTxts font-medium text-xs lg:text-sm py-1">
                          {t("masters.headerTexts.alarms")}
                        </label>
                      </div>
                    )}
                  {details &&
                    details?.alarms &&
                    details?.alarms.map(
                      (i, index) =>
                        i.parameterId === item.parameterId && (
                          <AlarmViewer
                            action={true}
                            alarm={i}
                            index={index}
                            onAlarmToggleEnable={onAlarmToggleEnable}
                            onEditAlarm={onEditAlarm}
                            item={item}
                            t={t}
                            onParamBgColorChange={onParamBgColorChange}
                          />
                        )
                    )}
                </div>
              );
            })}
        </div>
      </div>
      <div className="flex justify-center items-center sticky bg-inherit w-full bottom-0 gap-3 ">
        <div className="flex justify-center items-center mt-3 gap-3 pl-12">
          <div className="flex justify-center form-check form-check-inline mr-2">
            <label
              className="form-check-label inline-block text-xs lg:text-sm dark:text-white text-labels mr-3 mt-1"
              forhtml="inlineCheckbox1"
            >
              {t("masters.fields.active")}
            </label>
            <input
              name="active"
              type="checkbox"
              className="focus:ring-blue-500 h-4 lg:h-5 w-4 lg:w-5 text-blue-600 border-gray-300 rounded mt-1"
              id="inlineCheckbox1"
              // defaultChecked={true}
              onChange={onCheckboxChange}
              checked={details?.active}
              value={details?.active}
            ></input>
          </div>
          <button
            type="button"
            onClick={onCloseClick}
            className=" dark:bg-white bg-closeBtns dark:text-black text-closeBtnTxts text-xs lg:text-sm rounded-4xl px-10 lg:w-48 h-10"
          >
            {t("button.close")}
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={
              loading.formLoading ||
              details?.name === "" ||
              (details.companyAssign && details.companyId === null)
            }
            className="dark:bg-indigo-700 bg-submitBtns dark:text-white text-submitBtnTxts disabled:opacity-40 text-xs lg:text-sm rounded-4xl px-10 lg:w-48 h-10 flex justify-center items-center gap-3"
          >
            {loading.formLoading && <BtnLoader />}
            {details?.id ? t("button.update") : t("button.create")}
          </button>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </div>
  );
};

export default AssetTypePropertyForm;
